import React from 'react';

import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import HeaderNav from '../HeaderNav';

const db = firebase.firestore();

export default function StaffPageHOC(WrappedComponent) {
  return function StaffPage (props) {
    const { user, } = props;

    return (user.admin || user.isStaff) && (
      <div className="page d-flex flex-column" style={{ minHeight: '100vh' }}>
        <HeaderNav {...{ ...props, }} />
        <div className="d-flex flex-fill">
          <div className="flex-fill">
            <WrappedComponent {...{ ...props, }} />
          </div>
        </div>
      </div>
    );
  };
};
